import { Card } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { Description } from "@mui/icons-material";
import VoyageLog from "components/voyages/VoyageLog";
import { useQuery } from "@apollo/client";
import { VoyageLogDocument } from "__generated__/view/voyages/graphql/voyage.queries.generated";
import { Box, CircularProgress } from "@mui/material";

const VoyageLogDetails = ({ voyageId }: { voyageId: number }) => {

	const { data, loading } = useQuery(VoyageLogDocument, {
		variables: { id: voyageId },
	});

	return loading || !data ? (
		<Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
			<CircularProgress size={24} />
		</Box>
	) : (
		<Card
			title={intl.formatMessage({ id: "VOYAGELOG" })}
			icon={<Description fontSize="small" />}
			disablePadding>
			<VoyageLog report={data.voyageLog} />
		</Card>
	);
};

export default VoyageLogDetails;
